import { useTranslation } from 'react-i18next'
import { InlineNotice } from '@/components/feedback/inline-notice'
import { Button } from '@/components/primitives/button'
import { resolveBrandAssetSrc } from '@/features/shared/brand/branding-core'
import { useBranding } from '@/features/shared/brand/branding-hooks'
import { useWecomBindingPage } from './use-wecom-binding-page'
import { useMediaQuery } from '@/lib/use-media-query'
import { WecomBindingMobilePage } from './mobile/wecom-binding-mobile-page'

export function WecomBindingPage() {
  const isMobile = useMediaQuery('(max-width: 767px)')
  return isMobile ? <WecomBindingMobilePage /> : <WecomBindingDesktopPage />
}

function WecomBindingDesktopPage() {
  const { t } = useTranslation('wecomBinding')
  const {
    settings: { logo },
  } = useBranding()
  const { session, errorCode, loading, retry, authorize } = useWecomBindingPage()
  const result =
    session?.status === 'completed'
      ? 'success'
      : errorCode === 'binding_expired' || session?.status === 'expired'
        ? 'expired'
        : errorCode === 'channel_unavailable'
          ? 'channelClosed'
          : errorCode === 'binding_conflict' || session?.status === 'conflict'
            ? 'conflict'
            : errorCode
              ? 'error'
              : null
  return (
    <main className="min-h-dvh bg-[#f5f7fb] px-6 py-14 text-[var(--color-text)]">
      <section className="mx-auto grid w-full max-w-[680px] gap-6 rounded-2xl border border-[var(--color-panel-border)] bg-white p-10">
        <header className="grid justify-items-center gap-2 text-center">
          <img
            alt=""
            className="size-10 object-contain"
            data-testid="wecom-binding-brand-logo"
            src={resolveBrandAssetSrc(logo)}
          />
          <h1 className="text-xl font-semibold">{t('title')}</h1>
          <p className="text-sm leading-6 text-[var(--color-text-muted)]">
            {session?.app_display_name
              ? t('subtitleWithApp', { app: session.app_display_name })
              : t('subtitle')}
          </p>
        </header>
        {loading ? (
          <p className="text-center text-sm" role="status">
            {t('processing')}
          </p>
        ) : result ? (
          <InlineNotice tone={result === 'success' ? 'success' : 'danger'}>
            <strong>{t(`${result}.title`)}</strong>
            <p className="mt-2 text-sm leading-6">{t(`${result}.description`)}</p>
          </InlineNotice>
        ) : (
          <>
            <p className="text-sm leading-6 text-[var(--color-text-muted)]">
              {t('auth.description')}
            </p>
            <Button disabled={!session?.authorize_url} onClick={authorize}>
              {t('auth.action')}
            </Button>
          </>
        )}
        {!loading && result === 'error' ? (
          <Button onClick={retry} variant="secondary">
            {t('error.retry')}
          </Button>
        ) : null}
      </section>
    </main>
  )
}
